import { TStationRouteFieldName } from "../models";
import { VirtualDataKey } from "./common.const";

/** Keep in sync with BE `STORE_ROUTE_CACHE_DAYS_DEFAULT`. */
export const STORE_ROUTE_CACHE_DAYS_DEFAULT = 30;

export const ExcludedStationRouteIdsVirtualFieldName = `${VirtualDataKey}.excludedStationRouteIds`;
export const RideOpenerIdVirtualFieldName = `${VirtualDataKey}.rideOpenerId`;

export const StationRouteFormFields = {
  sourceRideIds: "metadata.sourceRideId",
  frozen: "frozen",
  customized: "customized",
  excludedStationRouteIds: ExcludedStationRouteIdsVirtualFieldName,
  rideOpenerId: RideOpenerIdVirtualFieldName,
} satisfies Record<string, TStationRouteFieldName>;
